module.exports = __webpack_public_path__ + "static/media/muna-convention-2023-al-quran-dawah.c342065a.png";